import styled, {css} from 'styled-components'

export const StyledSegmentedWrapper = styled.div`
    ${({theme}) => css`
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing}px;
    `}
`

export const StyledSegmentedBar = styled.div`
    ${({theme}) => css`
        display: inline-flex;
        width: 100%;
        max-width: 448px;
        border: 1px solid ${theme.palette.neutral['200']};
        border-radius: 6px;
        overflow: hidden;
    `}
`

export const StyledSegment = styled.button<{$selected: boolean; $isFirst: boolean}>`
    ${({theme, $selected, $isFirst}) => css`
        flex: 1;
        padding: ${theme.spacing * 1.5}px ${theme.spacing * 3}px;
        ${theme.typography.textSm};
        cursor: pointer;
        transition: ${theme.transition};
        border: none;
        border-left: ${$isFirst ? 'none' : `1px solid ${theme.palette.neutral['200']}`};
        background: ${$selected ? theme.palette.primary['50'] : theme.palette.neutral.white};
        color: ${$selected ? theme.palette.primary['700'] : theme.palette.neutral['600']};
        font-weight: ${$selected ? 500 : 400};

        &:hover {
            background: ${$selected ? theme.palette.primary['50'] : theme.palette.neutral['50']};
        }
    `}
`

export const StyledSegmentedCaption = styled.p`
    ${({theme}) => css`
        ${theme.typography.textXs};
        color: ${theme.palette.neutral['400']};
    `}
`
